import moment from "@/core/moment/moment-defaults";
// moment.tz.setDefault("Europe/Moscow")

export const formatUnixDateFilter = function (value: number, format = 'DD.MM.YYYY HH:mm:ss'): string {
  return moment.unix(value).format(format);
};
